import React from "react";
import Background from "./images/bground.png";
import AIicon from "./images/AI-Icon.png";
import LogIcon from "./images/login-signup.png";
import PathReviewIcon from "./images/pathreview.png";
import CourseIcon from "./images/courses.png";

const PersonalPlan = () => {
  const planData = [
    {
      img: AIicon,
      heading: "AI Assessments",
      description:
        "The Skilling section builds directly on the insights from your AI Job Assessment, ensuring your skill development.",
    },
    {
      img: LogIcon,
      heading: "Log In / Sign Up",
      description:
        "Create an account or log in to access personalized technical and soft skills courses.",
    },
    {
      img: PathReviewIcon,
      heading: "Learning Path",
      description:
        "Review your personalized learning path based on your AI Assessment results, with guidance on both technical and soft skill development.",
    },
    {
      img: CourseIcon,
      heading: "Enroll Courses",
      description:
        "Choose courses that fit your schedule and learning preferences.",
    },
  ];

  return (
    <div className="w-full flex flex-col">
      {/* Background Section */}
      <div
        className="relative w-full flex flex-col justify-center"
        style={{
          backgroundImage: `url(${Background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "50vh",
        }}
      >
        {/* Heading */}
        <h1 className="text-center md:text-left text-lg sm:text-xl md:text-2xl lg:text-4xl text-white font-bold my-8 px-4 md:pl-12">
          <span className="block">Getting Started with Your</span>
          <span className="block">Personalized Skilling Plan</span>
        </h1>

        {/* Cards Section */}
        <div className="hidden md:flex flex-wrap absolute bottom-[-20%] left-0 w-full px-4 justify-center gap-6">
          {planData.map((item, index) => (
            <div
              key={index}
              className="relative bg-white rounded-lg shadow-lg p-6 w-44 sm:w-52 md:w-56 lg:w-64 text-center transform transition hover:scale-105"
            >
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-custom-gradient rounded-full w-16 h-16 flex items-center justify-center">
                <img src={item.img} alt={item.heading} className="w-8 h-8" />
              </div>
              <h2 className="mt-8 font-bold text-base sm:text-lg md:text-xl text-custom-blue">
                {item.heading}
              </h2>
              <p className="text-border-gray mt-2 text-sm md:text-base font-normal">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Cards Section for Small Screens */}
      <div className="flex flex-wrap md:hidden px-4 py-6 gap-4 justify-center">
        {planData.map((item, index) => (
          <div
            key={index}
            className="relative bg-white rounded-lg shadow-lg p-6 w-full sm:w-52 md:w-56 text-center"
          >
            <div className="bg-custom-gradient rounded-full w-16 h-16 mx-auto flex items-center justify-center mb-4">
              <img src={item.img} alt={item.heading} className="w-8 h-8" />
            </div>
            <h2 className="font-bold text-lg sm:text-xl text-custom-blue">
              {item.heading}
            </h2>
            <p className="text-border-gray mt-2 text-sm sm:text-base font-normal">
              {item.description}
            </p>
          </div>
        ))}
      </div>

      {/* White Section */}
      <div className="w-full bg-white flex justify-center items-start py-20"></div>
    </div>
  );
};

export default PersonalPlan;
